import { render, staticRenderFns } from "./explorer.vue?vue&type=template&id=87b91e9c&"
import script from "./explorer.vue?vue&type=script&lang=js&"
export * from "./explorer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports